import { Button } from "Components/Button";
import { TooltipButtonDetails } from "Pages/PreBudgetList/components/TooltipButtonDetails";
import { PreOrderUnitListItem } from "Requests/PreOrder";
import { formatDateBR } from "Utils/Date";
import { MaskCPF } from "Utils/Masks";
import { Eye } from "lucide-react";
import { useEffect, useState } from "react";

interface PrePreOrderListRowProps {
  item: PreOrderUnitListItem;
}

function formatNumber(num: number) {
  return String(num).padStart(2, "0");
}

export const PrePreOrderListRow = ({ item }: PrePreOrderListRowProps) => {
  const { locked_at, locked_by, status } = item;

  const blockedView = status === "Processando";

  function getTimeRemaining() {
    if (locked_at) {
      const now = new Date().getTime();
      const distance = new Date(locked_at.replace(" ", "T")).getTime() - now;
      if (distance <= 0) {
        return "00:00";
      }

      return `${formatNumber(Math.floor((distance / 1000 / 60) % 60))}min`;
    }

    return "00:00";
  }

  const [timeLeft, setTimeLeft] = useState(getTimeRemaining());

  function handleOpenConversion() {
    window.open(`/converter-pre-pedido-ia/${item.id}/unidade`);
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getTimeRemaining());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <tr>
      <td>
        {item.ddd}
        {item.phone || "Não informado"}
      </td>
      <td>{item.full_name || "Não informado"}</td>
      <td>{MaskCPF(item.document) || "Não informado"}</td>
      <td>{item.have_health_insurance ? "Convênio" : "Particular"}</td>
      <td>{formatDateBR(item.created_at) || "Não informado"}</td>
      <td>{item.status || "Não informado"}</td>

      {blockedView ? (
        <td />
      ) : (
        <td className="text-center">
          {locked_by && timeLeft !== "00:00" ? (
            <TooltipButtonDetails tooltip={`Edição liberada em ${timeLeft}`}>
              <Eye color="#80008059" />
            </TooltipButtonDetails>
          ) : (
            <Button textButton onClick={handleOpenConversion} width="full">
              <Eye color="purple" />
            </Button>
          )}
        </td>
      )}
    </tr>
  );
};
